import { Landmark, ShieldCheck, WalletCards } from "lucide-react";
import "./withdrawlhistory/WithdrawalListPage.css";

const WithdrawlRequest = () => {
  return (
    <section className="withdrawal-page">
      <div className="withdrawal-shell">
        <header className="withdrawal-hero">
          <div className="withdrawal-hero-icon">
            <WalletCards size={24} />
          </div>

          <div className="withdrawal-hero-copy">
            <span className="withdrawal-eyebrow">MY WALLET</span>
            <h1>Withdrawal Request</h1>
            <p>
              Request a payout from your available wallet balance.
            </p>
          </div>

          <span className="withdrawal-record-count">
            <ShieldCheck size={14} />
            Secure payout
          </span>
        </header>

        <div className="withdrawal-empty">
          <Landmark size={27} strokeWidth={1.7} />
          <strong>Withdrawal Request</strong>
          <span>
            Withdrawal requests will be available here once the
            feature is enabled for your account.
          </span>
        </div>
      </div>
    </section>
  );
};

export default WithdrawlRequest;
